import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cancel-flow__screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__eyebrow" }, "Welcome back!", -1)
const _hoisted_3 = { class: "cancel-flow__main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "cancel-flow__heading cancel-flow__heading--accepted" }, "Your discount has been applied!", -1)
const _hoisted_5 = { class: "cancel-flow__body" }
const _hoisted_6 = { class: "cancel-flow__info-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Subscription type:"),
  /*#__PURE__*/_createTextVNode(" Annual")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Discount applied:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Renews on:", -1)
const _hoisted_11 = { class: "cancel-flow__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(" We've updated your subscription with "),
        _createElementVNode("strong", null, _toDisplayString(_ctx.offerLabel), 1),
        _createTextVNode(". You'll continue enjoying Ditto without interruption! ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        (_ctx.discountLabel)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.discountLabel), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.periodEndLabel), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('done')))
      }, "Got it, return to my account")
    ])
  ]))
}